module.exports = __webpack_public_path__ + "img/bg.c50cf301.png";